/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VideoActionConfig } from './VideoActionConfig';
import {
    VideoActionConfigFromJSON,
    VideoActionConfigFromJSONTyped,
    VideoActionConfigToJSON,
    VideoActionConfigToJSONTyped,
} from './VideoActionConfig';
import type { RewardAutoSettingsMap } from './RewardAutoSettingsMap';
import {
    RewardAutoSettingsMapFromJSON,
    RewardAutoSettingsMapFromJSONTyped,
    RewardAutoSettingsMapToJSON,
    RewardAutoSettingsMapToJSONTyped,
} from './RewardAutoSettingsMap';
import type { PlayableAdPlacement } from './PlayableAdPlacement';
import {
    PlayableAdPlacementFromJSON,
    PlayableAdPlacementFromJSONTyped,
    PlayableAdPlacementToJSON,
    PlayableAdPlacementToJSONTyped,
} from './PlayableAdPlacement';
import type { MiniGameConfig } from './MiniGameConfig';
import {
    MiniGameConfigFromJSON,
    MiniGameConfigFromJSONTyped,
    MiniGameConfigToJSON,
    MiniGameConfigToJSONTyped,
} from './MiniGameConfig';
import type { SurfaceDisplayScope } from './SurfaceDisplayScope';
import {
    SurfaceDisplayScopeFromJSON,
    SurfaceDisplayScopeFromJSONTyped,
    SurfaceDisplayScopeToJSON,
    SurfaceDisplayScopeToJSONTyped,
} from './SurfaceDisplayScope';
import type { PlayableAdFormat } from './PlayableAdFormat';
import {
    PlayableAdFormatFromJSON,
    PlayableAdFormatFromJSONTyped,
    PlayableAdFormatToJSON,
    PlayableAdFormatToJSONTyped,
} from './PlayableAdFormat';
import type { TriviaConfig } from './TriviaConfig';
import {
    TriviaConfigFromJSON,
    TriviaConfigFromJSONTyped,
    TriviaConfigToJSON,
    TriviaConfigToJSONTyped,
} from './TriviaConfig';
import type { HostRef } from './HostRef';
import {
    HostRefFromJSON,
    HostRefFromJSONTyped,
    HostRefToJSON,
    HostRefToJSONTyped,
} from './HostRef';
import type { ProductShowcaseConfig } from './ProductShowcaseConfig';
import {
    ProductShowcaseConfigFromJSON,
    ProductShowcaseConfigFromJSONTyped,
    ProductShowcaseConfigToJSON,
    ProductShowcaseConfigToJSONTyped,
} from './ProductShowcaseConfig';

/**
 * Playable ad-specific configuration
 * @export
 * @interface ActivationPlayableAdConfig
 */
export interface ActivationPlayableAdConfig {
    /**
     * 
     * @type {PlayableAdFormat}
     * @memberof ActivationPlayableAdConfig
     */
    adFormat?: PlayableAdFormat;
    /**
     * 
     * @type {PlayableAdPlacement}
     * @memberof ActivationPlayableAdConfig
     */
    placement?: PlayableAdPlacement;
    /**
     * Surfaces this ad displays on. Read when displayScope is SPECIFIC_SURFACES.
     * @type {Array<HostRef>}
     * @memberof ActivationPlayableAdConfig
     */
    hosts?: Array<HostRef>;
    /**
     * 
     * @type {SurfaceDisplayScope}
     * @memberof ActivationPlayableAdConfig
     */
    displayScope?: SurfaceDisplayScope;
    /**
     * Per-user completion cap
     * @type {number}
     * @memberof ActivationPlayableAdConfig
     */
    maxCompletionsPerUser?: number;
    /**
     * Global cap on total completions across all users
     * @type {number}
     * @memberof ActivationPlayableAdConfig
     */
    maxCompletions?: number;
    /**
     * Global cap on total reward claims across all users
     * @type {number}
     * @memberof ActivationPlayableAdConfig
     */
    maxClaims?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivationPlayableAdConfig
     */
    rewardConfigId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ActivationPlayableAdConfig
     */
    bonusRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {RewardAutoSettingsMap}
     * @memberof ActivationPlayableAdConfig
     */
    rewardAutoSettings?: RewardAutoSettingsMap;
    /**
     * 
     * @type {TriviaConfig}
     * @memberof ActivationPlayableAdConfig
     */
    triviaConfig?: TriviaConfig;
    /**
     * 
     * @type {MiniGameConfig}
     * @memberof ActivationPlayableAdConfig
     */
    miniGameConfig?: MiniGameConfig;
    /**
     * 
     * @type {VideoActionConfig}
     * @memberof ActivationPlayableAdConfig
     */
    videoActionConfig?: VideoActionConfig;
    /**
     * 
     * @type {ProductShowcaseConfig}
     * @memberof ActivationPlayableAdConfig
     */
    productShowcaseConfig?: ProductShowcaseConfig;
    /**
     * Data pipeline sources for this playable ad (e.g. OVERWOLF, BLITZ, WEBHOOK)
     * @type {Array<string>}
     * @memberof ActivationPlayableAdConfig
     */
    sources?: Array<string>;
}



/**
 * Check if a given object implements the ActivationPlayableAdConfig interface.
 */
export function instanceOfActivationPlayableAdConfig(value: object): value is ActivationPlayableAdConfig {
    return true;
}

export function ActivationPlayableAdConfigFromJSON(json: any): ActivationPlayableAdConfig {
    return ActivationPlayableAdConfigFromJSONTyped(json, false);
}

export function ActivationPlayableAdConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivationPlayableAdConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'adFormat': json['adFormat'] == null ? undefined : PlayableAdFormatFromJSON(json['adFormat']),
        'placement': json['placement'] == null ? undefined : PlayableAdPlacementFromJSON(json['placement']),
        'hosts': json['hosts'] == null ? undefined : ((json['hosts'] as Array<any>).map(HostRefFromJSON)),
        'displayScope': json['displayScope'] == null ? undefined : SurfaceDisplayScopeFromJSON(json['displayScope']),
        'maxCompletionsPerUser': json['maxCompletionsPerUser'] == null ? undefined : json['maxCompletionsPerUser'],
        'maxCompletions': json['maxCompletions'] == null ? undefined : json['maxCompletions'],
        'maxClaims': json['maxClaims'] == null ? undefined : json['maxClaims'],
        'rewardConfigId': json['rewardConfigId'] == null ? undefined : json['rewardConfigId'],
        'bonusRewardConfigIds': json['bonusRewardConfigIds'] == null ? undefined : json['bonusRewardConfigIds'],
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : RewardAutoSettingsMapFromJSON(json['rewardAutoSettings']),
        'triviaConfig': json['triviaConfig'] == null ? undefined : TriviaConfigFromJSON(json['triviaConfig']),
        'miniGameConfig': json['miniGameConfig'] == null ? undefined : MiniGameConfigFromJSON(json['miniGameConfig']),
        'videoActionConfig': json['videoActionConfig'] == null ? undefined : VideoActionConfigFromJSON(json['videoActionConfig']),
        'productShowcaseConfig': json['productShowcaseConfig'] == null ? undefined : ProductShowcaseConfigFromJSON(json['productShowcaseConfig']),
        'sources': json['sources'] == null ? undefined : json['sources'],
    };
}

export function ActivationPlayableAdConfigToJSON(json: any): ActivationPlayableAdConfig {
    return ActivationPlayableAdConfigToJSONTyped(json, false);
}

export function ActivationPlayableAdConfigToJSONTyped(value?: ActivationPlayableAdConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adFormat': PlayableAdFormatToJSON(value['adFormat']),
        'placement': PlayableAdPlacementToJSON(value['placement']),
        'hosts': value['hosts'] == null ? undefined : ((value['hosts'] as Array<any>).map(HostRefToJSON)),
        'displayScope': SurfaceDisplayScopeToJSON(value['displayScope']),
        'maxCompletionsPerUser': value['maxCompletionsPerUser'],
        'maxCompletions': value['maxCompletions'],
        'maxClaims': value['maxClaims'],
        'rewardConfigId': value['rewardConfigId'],
        'bonusRewardConfigIds': value['bonusRewardConfigIds'],
        'rewardAutoSettings': RewardAutoSettingsMapToJSON(value['rewardAutoSettings']),
        'triviaConfig': TriviaConfigToJSON(value['triviaConfig']),
        'miniGameConfig': MiniGameConfigToJSON(value['miniGameConfig']),
        'videoActionConfig': VideoActionConfigToJSON(value['videoActionConfig']),
        'productShowcaseConfig': ProductShowcaseConfigToJSON(value['productShowcaseConfig']),
        'sources': value['sources'],
    };
}

